"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const States_1 = require("../../../lib/constants/States");
const Tracking_1 = require("../../../lib/constants/Tracking");
const Banners_1 = require("../../Banners");
const Shimmer_1 = __importDefault(require("./Shimmer"));
const styles_1 = require("../styles");
const propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    track: prop_types_1.func.isRequired
};
function LoadingProvider({ service, track }) {
    const [state] = (0, react_2.useService)(service);
    (0, react_1.useEffect)(() => {
        if (state.matches(States_1.bookingDisabled)) {
            track(Tracking_1.userEvents.BOOKING_DISABLED);
        }
        if (state.matches(States_1.noResults)) {
            track(Tracking_1.userEvents.GENERIC_LOAD_ERROR);
        }
    }, [state, track]);
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "LoadingProvider" },
        state.matches(States_1.pending) && react_1.default.createElement(Shimmer_1.default, null),
        (state.matches(States_1.noResults) || state.matches(States_1.bookingDisabled)) && (react_1.default.createElement(Banners_1.ErrorBookingBanner, null))));
}
exports.default = LoadingProvider;
LoadingProvider.propTypes = propTypes;
//# sourceMappingURL=LoadingProvider.js.map